import React from 'react';

const sizeMap = {
  sm: 12,
  md: 16,
  lg: 20,
} as const;

type LoadingIconProps = {
  size: keyof typeof sizeMap;
};

export function LoadingIcon({ size }: LoadingIconProps) {
  const px = sizeMap[size];

  return (
    <>
      <svg
        className="wk-button-spinner"
        width={px}
        height={px}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle
          cx="8"
          cy="8"
          r="6.5"
          stroke="currentColor"
          strokeOpacity="0.05"
          strokeWidth="1"
        />
        <path
          d="M14.5 8a6.5 6.5 0 0 0-6.5-6.5"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
        />
      </svg>
      <style jsx>{`
        @keyframes wk-button-spin {
          to {
            transform: rotate(360deg);
          }
        }
        .wk-button-spinner {
          animation: wk-button-spin 1s linear infinite;
          flex-shrink: 0;
        }
      `}</style>
    </>
  );
}
